/*
  ruru. studios - Adventskalender-Builder (12.09.2026, Journey neu 09.10.2026)

  Gehoert zu sections/section-advent-builder.liquid (dort steht der
  ganze Ablauf und warum der Kalender ein eigenes Produkt ist).

  Schritte: 0 Start, 1 Style-Profil, 2 Tuerchen, 3 zwei Boxen (je eine Farbe).
  Das Board zeigt 24 Tuerchen: ungerade waehlt die Kundin (Schmuck),
  gerade sind verpackte Ueberraschungen. Die Verteilung ist nur optisch, ruru. legt
  Sticker bei. Intern bleiben die Picks "Schmuck-Tuerchen 1-12"
  (= Kategorie 1-12). Keine Emojis, keine Preise pro Stueck.
  Farben: waehlbare Tuerchen bekommen abwechselnd ad__door--c1 bis c6
  (ruru.-Flaechenfarben, CSS in der Section).
*/

var RURU_BOW = '<svg class="ad__bow" viewBox="0 0 48 28" aria-hidden="true">' +
  '<path d="M24 15C17 4 5 2 5 11c0 7 9 8 19 4Z"/>' +
  '<path d="M24 15C31 4 43 2 43 11c0 7-9 8-19 4Z"/>' +
  '<path class="ad__bow-tail" d="M22 16l-6 11M26 16l6 11"/>' +
  '<circle class="ad__bow-knot" cx="24" cy="15" r="4"/>' +
  '</svg>';

/* Stern fuer die Surprise-Tuerchen (statt Masche, Wunsch 09.10.2026). */
var RURU_STAR = '<svg class="ad__star" viewBox="0 0 24 24" aria-hidden="true">' +
  '<path d="M12 1.4l3.2 6.6 7.3 1-5.3 5.1 1.3 7.2L12 17.9l-6.5 3.4 1.3-7.2L1.5 9l7.3-1Z"/></svg>';

if (!customElements.get('ruru-advent')) {
  customElements.define('ruru-advent', class extends HTMLElement {
    connectedCallback() {
      var raw = this.querySelector('[data-advent-data]');
      if (!raw) return;
      this.rawData = raw.textContent;
      this.d = JSON.parse(this.rawData);
      this.t = this.d.t;
      /* 12.10.2026: auf Deutsch ueberall "Tuerli" statt "Tuerchen" (Wunsch ruru.),
         auch in Texten, die aus der Section kommen. */
      if ((document.documentElement.lang || 'de').indexOf('de') === 0) {
        var tl = function (x) { return typeof x === 'string' ? x.replace(/Türchen/g, 'Türli') : x; };
        for (var tk in this.t) this.t[tk] = tl(this.t[tk]);
        this.d.cats.forEach(function (c) { c.t = tl(c.t); c.b = tl(c.b); });
        var tw = document.createTreeWalker(this, NodeFilter.SHOW_TEXT, null);
        while (tw.nextNode()) { if (tw.currentNode.nodeValue.indexOf('Türchen') !== -1) tw.currentNode.nodeValue = tl(tw.currentNode.nodeValue); }
      }
      this.cats = this.d.cats.map(this.prep.bind(this));
      this.fixTitles();
      this.size = this.d.size;
      this.picks = {};
      this.posOf = {};
      this.step = 0;
      this.boxes = { 1: null, 2: null };

      this.board = this.querySelector('[data-advent-board]');
      this.sheet = this.querySelector('[data-advent-sheet]');
      this.opts = this.querySelector('[data-advent-opts]');
      this.status = this.querySelector('[data-advent-status]');
      this.bar = this.querySelector('[data-advent-bar]');
      this.stepper = this.querySelector('[data-advent-stepper]');

      var self = this;

      var start = this.querySelector('[data-advent-start]');
      if (start) start.addEventListener('click', function () { self.setStep(1); });

      this.querySelectorAll('[data-advent-goto]').forEach(function (b) {
        b.addEventListener('click', function () { self.setStep(Number(b.dataset.adventGoto)); });
      });

      var next = this.querySelector('[data-advent-next]');
      if (next) next.addEventListener('click', function () {
        var q = self.quizData();
        var qs = self.querySelector('[data-advent-quiz-status]');
        if (!q.ok) {
          if (qs) qs.textContent = self.t.quiz || self.t.error;
          var cv = document.getElementById('ruru-quiz-colors-value');
          var ce = document.getElementById('ruru-quiz-colors-error');
          if (ce && cv && !cv.value) ce.hidden = false;
          return;
        }
        if (qs) qs.textContent = '';
        self.setStep(2);
      });

      var lucky = this.querySelector('[data-advent-all]');
      if (lucky) lucky.addEventListener('click', function () { self.fillAll(); });

      var reset = this.querySelector('[data-advent-reset]');
      if (reset) reset.addEventListener('click', function () { self.picks = {}; self.render(); });

      this.querySelectorAll('[data-advent-box]').forEach(function (r) {
        r.addEventListener('change', function () {
          if (r.checked) { self.boxes[r.dataset.adventBox] = { value: r.value, label: r.dataset.label || r.value, variant: Number(r.dataset.variant) || 0 }; }
          self.render();
        });
      });

      var cta = this.querySelector('[data-advent-cta]');
      if (cta) cta.addEventListener('click', function () {
        if (self.step === 2) {
          if (self.filledCount() >= self.size.doors) self.setStep(3);
        } else if (self.step === 3) {
          self.addToCart();
        }
      });

      if (this.stepper) {
        this.stepper.querySelectorAll('li').forEach(function (li) {
          li.setAttribute('role', 'button');
          li.tabIndex = 0;
          var go = function () { self.gotoStep(Number(li.dataset.s)); };
          li.addEventListener('click', go);
          li.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
          });
        });
      }

      this.buildPreview();
      this.build();
      this.buildMode();
      this.setStep(0, true);
      this.loadSubs();
    }

    /* 12.10.2026: Bei einigen Produkten liefert Shopify auf Deutsch kaputte
       Variantentitel (veraltete Uebersetzungen pro Variante, z.B. Salma
       "Vergoldet / Paar" ohne Groesse, oder "Medium"). Dann fehlen Teile und
       Groessen/Farben lassen sich nicht trennen. Die Zuordnung der Zwillinge
       kommt auf Englisch mit vollstaendigem Titel: damit die kaputten Titel
       ersetzen und die Kategorien neu aufbauen. */
    fixTitles(tries) {
      var self = this;
      tries = tries || 0;
      fetch('/en?sections=ruru-advent-twins', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('map'); return r.json(); })
        .then(function (j) {
          var html = (j && j['ruru-advent-twins']) || '';
          var m = html.match(/<script[^>]*data-advent-twins[^>]*>([\s\S]*?)<\/script>/);
          var map = m ? JSON.parse(m[1]) : {};
          var d = JSON.parse(self.rawData);
          var changed = false;
          d.cats.forEach(function (c) {
            (c.o || []).forEach(function (p) {
              var n = (p.on || []).length;
              if (!n || !p.v) return;
              var bad = p.v.some(function (v) { return v.t.split(' / ').length !== n || /^medium$/i.test(v.t.split(' / ').pop()); });
              if (!bad) return;
              var all = p.v.every(function (v) { return map[v.id] && map[v.id].o && map[v.id].o.split(' / ').length === n; });
              if (!all) return;
              p.v.forEach(function (v) { v.t = map[v.id].o; });
              changed = true;
            });
          });
          if (!changed) return;
          self.d.cats = d.cats;
          self.cats = d.cats.map(self.prep.bind(self));
          self.loadSubs();
        })
        .catch(function () {
          /* 12.10.2026: bei einem Fehler bis zu zweimal neu versuchen */
          if (tries < 2) setTimeout(function () { self.fixTitles(tries + 1); }, 1500);
        });
    }

    /* 11.10.2026: Portemonnaies sind nicht gelistet (erscheinen in keiner
       Kollektion) und Beanies sind einzelne Produkte pro Farbe. Darum laedt
       der Builder die Auswahl direkt per Handle. Ausverkauftes faellt weg. */
    loadSubs() {
      /* 12.10.2026: Im Extra-Tuerchen jedes Stueck einzeln zeigen (Wunsch ruru.):
         beide Travel Cases, der Koffertag, jedes Portemonnaie, jede Beanie-Farbe.
         Gewaehlt wird dann das echte Produkt (wie ein normales Schmuckstueck). */
      var self = this;
      var lists = {
        'case': ['travel-case'],
        tag: ['smiley-suitcase-tag'],
        purse: ['heart-coin-purse', 'gigi-pouch', 'bisou-pouch', 'amalia-pouch', 'wilson-pouch', 'selene-pouch', 'hot-mess-pouch'],
        beanie: ['beanie-black', 'beanie-white', 'beanie-beige', 'beanie-lavender']
      };
      var size = function (img) { return img ? img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=400' : ''; };
      this.cats.forEach(function (cat) {
        if (cat.kind !== 'typ') return;
        var orig = cat.o.slice();
        Promise.all(orig.map(function (p) {
          var hs = lists[p.icon];
          if (!hs) return Promise.resolve([p]);
          return Promise.all(hs.map(function (h) {
            return fetch(self.root() + 'products/' + h + '.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.ok ? r.json() : null; })
              .catch(function () { return null; });
          })).then(function (res) {
            var cards = [];
            res.forEach(function (pr) {
              if (!pr || !pr.available) return;
              var avail = (pr.variants || []).filter(function (x) { return x.available; });
              var multi = avail.length > 1;
              avail.forEach(function (v) {
                var img = size((v.featured_image && v.featured_image.src) || pr.featured_image || '');
                var name = pr.title + (multi && v.option1 && v.option1 !== 'Default Title' ? ' · ' + v.option1 : '');
                cards.push({ n: name, i: img, v: [{ id: v.id, t: '', a: true, q: null, img: img }], a: true, stock: 50, xtra: true });
              });
            });
            return cards.length ? cards : [p];
          });
        })).then(function (groups) {
          var all = [];
          groups.forEach(function (g) { all = all.concat(g); });
          cat.o = all;
        });
      });
    }

    /* 11.10.2026: Vor der Auswahl fragen, ob die Kundin selbst waehlt oder sich
       komplett ueberraschen laesst (dann gar keine Produkte zeigen, direkt zu den Boxen). */
    buildMode() {
      var scr = this.querySelector('[data-advent-screen="2"]');
      if (!scr) return;
      var self = this;
      var de = (document.documentElement.lang || 'de').indexOf('de') === 0;
      if (!document.getElementById('ruru-advent-mode-css')) {
        var st = document.createElement('style');
        st.id = 'ruru-advent-mode-css';
        st.textContent =
          '.ad-mode{max-width:780px;margin:0 auto 70px;text-align:center}' +
          '.ad-mode .ad__sub{margin-left:auto;margin-right:auto}' +
          '.ad-mode__grid{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-top:20px}' +
          '@media (max-width:600px){.ad-mode__grid{grid-template-columns:1fr}}' +
          '.ad-mode__card{display:flex;flex-direction:column;align-items:center;gap:8px;padding:28px 20px 24px;border-radius:22px;border:2px solid transparent;background:#fff;box-shadow:0 10px 30px rgba(124,70,88,.10);cursor:pointer;font:inherit;color:#34496a;justify-content:flex-start;transition:transform .15s ease,border-color .15s ease}' +
          '.ad-mode__card:hover,.ad-mode__card:focus-visible{transform:translateY(-2px);border-color:#fc78a4;outline:none}' +
          '.ad-mode__ic{height:52px;display:flex;align-items:center;justify-content:center}' +
          '.ad-mode__ic svg{position:static!important;transform:none!important;width:52px!important;height:52px;display:block}' +
          '.ad-mode__ic svg.ad__bow{width:66px!important;height:40px}' +
          '.ad-mode__ic svg path,.ad-mode__ic svg circle{fill:#fc78a4;stroke:none}' +
          '.ad-mode__ic svg .ad__bow-tail{fill:none;stroke:#fc78a4;stroke-width:2.6;stroke-linecap:round}' +
          '.ad-mode__card b{font-family:\'ruru Gabarito\',inherit;font-size:21px;font-weight:800;line-height:1.15}' +
          '.ad-mode__card span{font-size:14.5px;line-height:1.45;opacity:.8;max-width:30ch;margin-bottom:10px}' +
          '.ad-mode__card em{font-style:normal;margin-top:auto;padding:10px 20px;border-radius:999px;background:#fc78a4;color:#34496a;font-weight:700;font-size:14px}' +
          '.ad-mode__card--all em{background:#fff;border:1.5px solid rgba(52,73,106,.2)}';
        document.head.appendChild(st);
      }
      var el = document.createElement('div');
      el.className = 'ad-mode';
      el.hidden = true;
      el.innerHTML =
        '<h2 class="ad__h2">' + (de ? 'Wie möchtest du deinen Kalender?' : 'How would you like your calendar?') + '</h2>' +
        '<p class="ad__sub" style="margin:0 auto 4px">' + (de ? 'Du kannst 12 Türli selbst aussuchen oder dich bei allen 24 überraschen lassen.' : 'Pick 12 doors yourself or let us surprise you with all 24.') + '</p>' +
        '<div class="ad-mode__grid">' +
          '<button type="button" class="ad-mode__card" data-mode="self"><span class="ad-mode__ic">' + RURU_BOW + '</span>' +
            '<b>' + (de ? 'Ja, ich wähle selbst' : 'Yes, I want to pick') + '</b>' +
            '<span>' + (de ? '12 Türli suchst du dir aus, die anderen 12 sind Überraschungen von uns.' : 'You pick 12 doors, the other 12 are surprises from us.') + '</span>' +
            '<em>' + (de ? '12 Türli auswählen' : 'Pick 12 doors') + '</em></button>' +
          '<button type="button" class="ad-mode__card ad-mode__card--all" data-mode="all"><span class="ad-mode__ic">' + RURU_STAR + '</span>' +
            '<b>' + (de ? 'Überrascht mich komplett' : 'Surprise me completely') + '</b>' +
            '<span>' + (de ? 'Wir packen alle 24 Türli passend zu deinem Style-Profil. Du siehst vorher nichts.' : 'We fill all 24 doors to match your style profile. You won\'t see anything in advance.') + '</span>' +
            '<em>' + (de ? 'Weiter zu den Boxen' : 'Continue to the boxes') + '</em></button>' +
        '</div>';
      scr.insertBefore(el, scr.firstChild);
      this.modeEl = el;
      this.modeScr = scr;
      this.mode = null;
      el.querySelector('[data-mode="self"]').addEventListener('click', function () {
        if (self.mode === 'all') self.picks = {};
        self.mode = 'self';
        self.showMode(false);
        self.render();
        var top = self.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      });
      el.querySelector('[data-mode="all"]').addEventListener('click', function () {
        self.mode = 'all';
        self.picks = {};
        self.fillAll();
        self.setStep(3);
      });
    }

    showMode(on) {
      if (!this.modeEl) return;
      var el = this.modeEl;
      el.hidden = !on;
      [].forEach.call(this.modeScr.children, function (c) { if (c !== el) c.hidden = on; });
      if (this.bar) this.bar.hidden = on;
    }

    /* Stepper: zurueck geht immer, vorwaerts nur, wenn der Schritt davor fertig ist. */
    gotoStep(n) {
      if (n === this.step) return;
      if (n >= 2 && !this.quizData().ok) {
        if (this.step !== 1) this.setStep(1);
        var qs = this.querySelector('[data-advent-quiz-status]');
        if (qs) qs.textContent = this.t.quiz || this.t.error;
        return;
      }
      if (n === 3 && this.filledCount() < this.size.doors) { this.setStep(2); return; }
      this.setStep(n);
    }

    /* "Gold Plated 925 Sterling Silver / XS | Hoop diameter: 6mm" -> "Gold · XS" */
    niceVariant(t) {
      var self = this;
      if (!t || t === 'Default Title') return '';
      return t.split(' / ').map(function (x) {
        return self.matLabel(x) || (self.sizeCode(x) ? self.sizeLabel(x) : self.colorDe(x.split(' | ')[0]));
      }).filter(Boolean).join(' · ');
    }

    /* Material aus dem Style-Profil (Gold/Silber), bei "Mix" Gold als Start. */
    profileMat() {
      var q = this.quizData().props['Gold oder Silber'];
      return q === 'Silber' ? 'silver' : 'gold';
    }

    matKey(t) {
      if (/gold/i.test(t)) return 'gold';
      if (/silver|silber/i.test(t)) return 'silver';
      return null;
    }

    /* Varianten eines Produkts, die zum gewaehlten Material passen.
       Produkte ohne Materialangabe bleiben unveraendert. */
    forMat(list) {
      var self = this, m = this.mat;
      var hasMat = list.some(function (v) { return self.matKey(v.t); });
      if (!hasMat) return list;
      return list.filter(function (v) { return self.matKey(v.t) === m; });
    }

    /* Kopfleiste im Auswahlfenster: Pfeile, Fortschritts-Punkte, Gold/Silber. */
    sheetBar(i, cat) {
      var self = this;
      var bar = this.sheet.querySelector('[data-advent-sbar]');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'ad__sbar';
        bar.setAttribute('data-advent-sbar', '');
        this.sheet.insertBefore(bar, this.opts);
      }
      var n = this.size.doors;
      var dots = '';
      for (var k = 1; k <= n; k++) {
        dots += '<button type="button" class="ad__dot' + (k === i ? ' is-cur' : '') + (this.picks[k] ? ' is-done' : '') + '" data-goto="' + k + '" aria-label="' + this.t.door + ' ' + (this.posOf[k] || k) + '"></button>';
      }
      var showMat = cat.kind !== 'typ' && cat.o.some(function (p) { return p.v.some(function (v) { return self.matKey(v.t); }); });
      bar.innerHTML =
        '<div class="ad__nav">' +
          '<button type="button" class="ad__arrow" data-step="-1" aria-label="' + (this.t.prev || 'Zurück') + '"' + (i <= 1 ? ' disabled' : '') + '>&#8249;</button>' +
          '<span class="ad__dots">' + dots + '</span>' +
          '<button type="button" class="ad__arrow" data-step="1" aria-label="' + (this.t.nextDoor || 'Weiter') + '"' + (i >= n ? ' disabled' : '') + '>&#8250;</button>' +
        '</div>' +
        (showMat ?
          '<div class="ad__mat" role="group">' +
            '<button type="button" data-mat="gold" class="' + (this.mat === 'gold' ? 'is-on' : '') + '"><i class="ad__swg"></i>' + (this.t.gold || 'Gold') + '</button>' +
            '<button type="button" data-mat="silver" class="' + (this.mat === 'silver' ? 'is-on' : '') + '"><i class="ad__sws"></i>' + (this.t.silver || 'Silber') + '</button>' +
          '</div>' : '');
      bar.querySelectorAll('[data-step]').forEach(function (b) {
        b.addEventListener('click', function () { self.open(i + Number(b.dataset.step)); });
      });
      bar.querySelectorAll('[data-goto]').forEach(function (b) {
        b.addEventListener('click', function () { self.open(Number(b.dataset.goto)); });
      });
      bar.querySelectorAll('[data-mat]').forEach(function (b) {
        b.addEventListener('click', function () { self.mat = b.dataset.mat; self.open(i); });
      });
    }

    /* Kategorie aufbereiten.
       Paar-Modus (Ohrringe): pro Material/Farbe zaehlt der Bestand als
       Paare + Einzelstuecke/2 (bzw. min(links, rechts)). Gewaehlt wird
       die Paar-Variante, falls es keine gibt die Einzelstueck-Variante
       (Team packt dann zwei Stueck). Foto = Variantenfoto (Paar).
       Mindestbestand blendet knappe Varianten aus. */
    prep(cat) {
      if (cat.kind === 'typ') {
        var self0 = this;
        cat.o.forEach(function (p) { p.i = p.img || self0.icon(p.icon); p.typ = true; });
        return cat;
      }
      var min = Number(cat.min) || 0;
      var out = [];
      var self1 = this;
      cat.o.forEach(function (p) {
        var on = p.on || [];
        var vs = p.v || [];
        if (!vs.length) return;
        var nv = [];
        if (cat.pair) {
          var setIdx = -1;
          var parts = vs.map(function (v) { return v.t.split(' / '); });
          for (var d = 0; d < parts[0].length; d++) {
            if (parts.every(function (x) { return /single|pair|paar|pärchen|pärli|einzel/i.test(x[d] || ''); })) { setIdx = d; break; }
          }
          var groups = {}, order = [];
          vs.forEach(function (v, k) {
            var x = parts[k];
            var key = x.filter(function (_, j) { return j !== setIdx; }).join(' / ');
            if (!groups[key]) { groups[key] = { pair: null, L: 0, R: 0, S: 0, single: null, lr: false }; order.push(key); }
            var g = groups[key];
            var sv = setIdx >= 0 ? x[setIdx] : '';
            var q = v.q === null || v.q === undefined ? (v.a ? 999 : 0) : Math.max(v.q, 0);
            /* 11.10.2026: deutsche Titel "Ein Pärchen (2 Einzelstücke)" / "Linkes Ohr" erkennen */
            if (/pair|paar|pärchen|pärli/i.test(sv)) { g.pair = v; g.pq = q; }
            else {
              if (!g.single || (!g.single.img && v.img)) g.single = v;
              if (/left|link/i.test(sv)) { g.L += q; g.lr = true; }
              else if (/right|recht/i.test(sv)) { g.R += q; g.lr = true; }
              else g.S += q;
            }
          });
          order.forEach(function (key) {
            var g = groups[key];
            var eq = (g.pq || 0) + (g.lr ? Math.min(g.L, g.R) + Math.floor(g.S / 2) : Math.floor(g.S / 2));
            var base = g.pair || g.single;
            if (!base) return;
            nv.push({ id: base.id, t: key || base.t, a: eq >= Math.max(min, 1), q: eq, img: (g.pair && g.pair.img) || base.img || null, two: !g.pair });
          });
          p.on = setIdx >= 0 ? on.filter(function (_, j) { return j !== setIdx; }) : on;
        } else {
          vs.forEach(function (v) {
            var ok = v.a && (v.q === null || v.q === undefined || v.q >= Math.max(min, 1));
            nv.push({ id: v.id, t: v.t, a: ok, q: v.q, img: v.img || null });
          });
        }
        /* 11.10.2026: Hat ein Produkt Gold (vergoldet) UND Vermeil, nur Gold zeigen.
           Vermeil bleibt nur, wenn es keine verfuegbare Gold-Variante gibt. */
        var isVer = function (v) { return /vermeil/i.test(v.t); };
        if (nv.some(function (v) { return v.a && !isVer(v) && /gold/i.test(v.t); })) {
          nv = nv.filter(function (v) { return !isVer(v); });
        }
        /* Ausverkaufte Varianten gar nicht erst anbieten */
        nv = nv.filter(function (v) { return v.a; });
        p.v = nv;
        var firstOk = nv.filter(function (v) { return v.a; });
        if (!firstOk.length) return;
        p.stock = firstOk.reduce(function (t, v) { return t + (v.q === null || v.q === undefined ? 50 : v.q); }, 0);
        if (cat.pair && firstOk[0].img) p.i = firstOk[0].img;
        p.a = true;
        /* 11.10.2026: Produkte mit mehreren Groessen (z.B. Rachel M/L) als
           eigene Karten zeigen, die Groesse steht direkt im Namen.
           12.10.2026: ebenso Farben (z.B. Eliza White/Light Blue/Lavender),
           damit man sieht, dass es viele Farben gibt. */
        var parts2 = nv.map(function (v) { return v.t.split(' / '); });
        var sd = -1, cd = -1, on2 = p.on || [];
        var nd = parts2[0].length;
        for (var d2 = 0; d2 < nd; d2++) {
          var nm = on2.length === nd ? String(on2[d2]) : '';
          if (parts2.every(function (x) { return self1.matKey(x[d2] || ''); })) continue;
          var isSize = /size|gr(ö|oe)sse|durchmesser|diameter/i.test(nm) ||
            parts2.every(function (x) { return self1.sizeCode(x[d2] || ''); });
          if (isSize && sd < 0) { sd = d2; continue; }
          if (/colou?r|farbe|stein|stone/i.test(nm) && cd < 0) cd = d2;
        }
        /* 12.10.2026: fehlt einer Groesse/Farbe das Foto (z.B. Scarlett L),
           das Foto derselben Farbe im selben Material uebernehmen (z.B. von M). */
        if (sd >= 0 || cd >= 0) {
          var srcImg = nv.concat(vs);
          /* 12.10.2026: Bei Groessen immer das Foto der Groesse M zeigen
             (L-Fotos sind oft Tragebilder, Wunsch ruru.). */
          if (sd >= 0) {
            nv.forEach(function (v, k) {
              if (self1.sizeCode(parts2[k][sd] || '') === 'M') return;
              for (var j = 0; j < srcImg.length; j++) {
                var o = srcImg[j], op = o.t.split(' / ');
                if (!o.img || self1.matKey(o.t) !== self1.matKey(v.t)) continue;
                if (cd >= 0 && op.indexOf(parts2[k][cd]) === -1) continue;
                if (!op.some(function (x) { return self1.sizeCode(x) === 'M'; })) continue;
                v.img = o.img; break;
              }
            });
          }
          nv.forEach(function (v, k) {
            if (v.img) return;
            for (var j = 0; j < srcImg.length; j++) {
              var o = srcImg[j];
              if (!o.img || self1.matKey(o.t) !== self1.matKey(v.t)) continue;
              if (cd >= 0 && o.t.split(' / ').indexOf(parts2[k][cd]) === -1) continue;
              v.img = o.img; break;
            }
          });
        }
        var uniqAt = function (d) { var u = []; if (d >= 0) parts2.forEach(function (x) { if (u.indexOf(x[d]) === -1) u.push(x[d]); }); return u; };
        var sizes = uniqAt(sd), colors = uniqAt(cd);
        /* Piercing Friendly: Groesse bleibt im Dropdown (Wunsch 11.10.2026, sonst zu viele Karten) */
        if (/piercing/i.test(cat.t || '')) sizes = [];
        if (sizes.length < 2) { sizes = []; sd = -1; }
        if (colors.length < 2) { colors = []; cd = -1; }
        if (!sizes.length && !colors.length) { out.push(p); return; }
        var rk = ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
        var rank = function (t) {
          var c = self1.sizeCode(t).replace('2XL', 'XXL').replace('3XL', 'XXXL');
          var i = rk.indexOf(c);
          var mm = String(t).match(/(\d+(?:[.,]\d+)?)\s*mm/i);
          return (i === -1 ? 50 : i) * 1000 + (mm ? parseFloat(mm[1].replace(',', '.')) : 0);
        };
        sizes.sort(function (a, b) { return rank(a) - rank(b); });
        var cl = colors.length ? colors : [null];
        var sl = sizes.length ? sizes : [null];
        /* 12.10.2026: bei einigen Modellen nur eine Groesse anbieten (Wunsch ruru.) */
        var onlySize = { 'Salma': 'M', 'Rachel': 'L', 'Thea': 'L' }[String(p.n).split(' ')[0]];
        cl.forEach(function (col) {
          sl.forEach(function (sz) {
            if (onlySize && sz !== null && self1.sizeCode(sz) !== onlySize) return;
            var sv = nv.filter(function (v, k) {
              return (col === null || parts2[k][cd] === col) && (sz === null || parts2[k][sd] === sz);
            });
            if (!sv.length) return;
            var q = Object.assign({}, p);
            q.v = sv;
            q.n0 = p.n;
            q.gs = p.stock;
            var lab = [];
            if (col !== null) lab.push(self1.colorDe(String(col).split(' | ')[0]));
            if (sz !== null) lab.push(self1.sizeLabel(sz));
            q.n = p.n + ' · ' + lab.join(' · ');
            q.stock = sv.reduce(function (t, v) { return t + (v.q === null || v.q === undefined ? 50 : v.q); }, 0);
            var wi = sv.filter(function (v) { return v.img; })[0];
            if (wi) q.i = wi.img;
            out.push(q);
          });
        });
      });
      /* Viel Bestand zuerst, damit die Wahl dort landet, wo genug da ist. */
      out.sort(function (a, b) { return (b.gs || b.stock || 0) - (a.gs || a.stock || 0); });
      cat.o = out;
      return cat;
    }

    isDe() { return (document.documentElement.lang || 'de').indexOf('de') === 0; }

    /* 12.10.2026: Farbnamen auf Deutsch zeigen (einige Varianten haben in
       Shopify nur englische Farbnamen, z.B. nach fixTitles). */
    colorDe(c) {
      if (!this.isDe()) return c;
      var m = { 'White': 'Weiss', 'Black': 'Schwarz', 'Green': 'Grün', 'Blue': 'Blau', 'Light Blue': 'Hellblau',
        'Lavender': 'Lavendel', 'Yellow': 'Gelb', 'Pink': 'Pink', 'Light Pink': 'Hellrosa', 'Red': 'Rot', 'Olive': 'Oliv',
        'Peach': 'Pfirsich', 'Multicolor': 'Bunt', 'Multicolour': 'Bunt', 'Plain': 'Ohne Steine', 'Purple': 'Lila',
        'Orange': 'Orange', 'Clear': 'Klar', 'Brown': 'Braun', 'Grey': 'Grau', 'Gray': 'Grau', 'Mint': 'Mint', 'Turquoise': 'Türkis' };
      return m[c] || c;
    }

    /* Groessen-Code am Anfang eines Optionswerts (XXS, XS, S, M, L, XL, 2XL ...) */
    sizeCode(t) {
      var m = String(t).trim().match(/^(XXXS|XXS|XS|S|M|L|XL|XXL|XXXL|[2-4]XL)(?=$|[\s|(])/);
      return m ? m[1] : '';
    }

    /* "M | Durchmesser: 15mm" -> "M · 15 mm", "M (5.0 - 7.5 | 49 - 55)" -> "Grösse M" */
    sizeLabel(t) {
      var code = this.sizeCode(t);
      var mm = String(t).match(/(\d+(?:[.,]\d+)?)\s*mm/i);
      if (code && mm) return code + ' · ' + mm[1] + ' mm';
      if (code) return (this.t.size || (this.isDe() ? 'Grösse' : 'Size')) + ' ' + code;
      return String(t).split(' | ')[0];
    }

    icon(kind) {
      var paths = {
        case: '<rect x="10" y="20" width="44" height="32" rx="9"/><path d="M24 20v-5a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v5M10 33h44"/><path d="M28 33v5h8v-5"/>',
        tag: '<path d="M14 22 30 10l20 0v24L30 54H14Z" transform="rotate(-8 32 32)"/><circle cx="41" cy="19" r="3.5"/><path d="M41 15c4-8 12-8 12 0"/><path d="M20 36h16M20 43h10"/>',
        purse: '<path d="M10 30c0-6 4-10 10-10h24c6 0 10 4 10 10v12c0 6-4 10-10 10H20c-6 0-10-4-10-10Z"/><path d="M24 20c0-6 4-8 8-8s8 2 8 8"/><circle cx="28" cy="21" r="3"/><circle cx="36" cy="21" r="3"/>',
        beanie: '<path d="M12 42c0-14 9-24 20-24s20 10 20 24"/><rect x="9" y="41" width="46" height="11" rx="4"/><circle cx="32" cy="13" r="5"/><path d="M18 46v2M24 46v2M30 46v2M36 46v2M42 46v2M48 46v2"/>'
      };
      var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" stroke="#34496a" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><rect x="-200" y="-200" width="600" height="600" fill="#eef4fd" stroke="none"/>' + (paths[kind] || paths.case) + '</svg>';
      return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
    }

    money(cents) {
      var v = (cents / 100).toFixed(2).replace('.00', '.–');
      return 'CHF ' + v;
    }

    catFor(i) { return this.cats[(i - 1) % this.cats.length]; }

    /* Positionen der verpackten Ueberraschungs-Tuerchen: streng
       abwechselnd, alle geraden Nummern (Wunsch ruru. 09.10.2026). */
    giftSlots(total) {
      var map = {};
      var list = [];
      for (var g = 2; g <= total; g += 2) list.push(g);
      list.forEach(function (n) { map[n] = true; });
      return map;
    }

    setStep(n, silent) {
      this.step = n;
      if (n === 2) this.mat = null;
      this.querySelectorAll('[data-advent-screen]').forEach(function (el) {
        el.hidden = Number(el.dataset.adventScreen) !== n;
      });
      if (this.stepper) {
        this.stepper.hidden = n === 0;
        this.stepper.querySelectorAll('li').forEach(function (li) {
          var s = Number(li.dataset.s);
          li.classList.toggle('is-active', s === n);
          li.classList.toggle('is-done', s < n);
        });
      }
      if (this.bar) this.bar.hidden = n < 2;
      if (n === 2) this.showMode(this.mode !== 'self');
      if (this.status) this.status.textContent = '';
      this.render();
      if (!silent) {
        var top = this.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      }
    }

    /* Farbe nach Position, 5er-Zyklus ueber alle 24 Tuerchen (ohne Gelb):
       ergibt in 3, 4 oder 6 Spalten eine schraege, nie gleiche Nachbarschaft. */
    colorOf(pos) { return 'ad__door--c' + (((pos - 1) % 5) + 1); }

    giftTile(pos) {
      var g = document.createElement('div');
      g.className = 'ad__door ad__door--gift ' + this.colorOf(pos);
      g.setAttribute('role', 'img');
      g.setAttribute('aria-label', this.t.door + ' ' + pos + ', ' + (this.t.surprise || 'Überraschung'));
      g.innerHTML =
        '<span class="ad__inner"><span class="ad__face ad__face--front">' +
          '<span class="ad__num">' + pos + '</span>' +
          '<span class="ad__tap ad__tap--gift">' + RURU_STAR + '<em>' + (this.t.gifttag || 'Surprise') + '</em></span>' +
        '</span></span>';
      return g;
    }

    /* Kleine, nicht klickbare Vorschau auf der Startseite. */
    buildPreview() {
      var prev = this.querySelector('[data-advent-preview]');
      if (!prev) return;
      var gifts = this.giftSlots(24);
      prev.innerHTML = '';
      var c = 0;
      for (var pos = 1; pos <= 24; pos++) {
        if (gifts[pos]) { prev.appendChild(this.giftTile(pos)); continue; }
        var d = document.createElement('div');
        d.className = 'ad__door ' + this.colorOf(pos);
        d.style.cursor = 'default';
        d.innerHTML = '<span class="ad__inner"><span class="ad__face ad__face--front"><span class="ad__num">' + pos + '</span></span></span>';
        prev.appendChild(d);
      }
    }

    build() {
      var self = this;
      this.board.innerHTML = '';
      this.posOf = {};
      var total = this.size.doors * 2;
      var gifts = this.giftSlots(total);
      var k = 0;
      for (var pos = 1; pos <= total; pos++) {
        if (gifts[pos] || k >= this.size.doors) {
          this.board.appendChild(this.giftTile(pos));
          continue;
        }
        k++;
        var i = k;
        this.posOf[i] = pos;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ad__door ' + this.colorOf(pos);
        b.dataset.i = i;
        b.dataset.pos = pos;
        b.setAttribute('aria-label', this.t.door + ' ' + pos);
        b.innerHTML =
          '<span class="ad__badge">' + pos + '</span>' +
          '<span class="ad__inner">' +
            '<span class="ad__face ad__face--front">' +
              '<span class="ad__num">' + pos + '</span>' +
              '<span class="ad__tap">' + (this.t.pick || 'Wählen') + '</span>' +
            '</span>' +
            '<span class="ad__face ad__face--back">' +
              '<img alt="" loading="lazy"><span class="ad__cap"></span>' +
            '</span>' +
          '</span>';
        b.addEventListener('click', function () { self.open(Number(this.dataset.i)); });
        this.board.appendChild(b);
      }
      this.render();
    }

    /* Box-Bestand: ist eine Farbe nur noch 1x da und in der anderen Box
       schon gewaehlt, ist sie hier nicht mehr waehlbar. */
    boxStock() {
      var self = this;
      this.querySelectorAll('[data-advent-box]').forEach(function (r) {
        var n = r.dataset.adventBox, other = self.boxes[n === '1' ? 2 : 1];
        var stock = Number(r.dataset.stock || 999);
        var left = stock - (other && other.value === r.value ? 1 : 0);
        var off = left < 1 && !r.checked;
        r.disabled = off;
        r.closest('.ad__box').classList.toggle('is-off', off);
      });
    }

    boxesDone() { return !!(this.boxes[1] && this.boxes[2]); }

    filledCount() {
      var n = 0;
      for (var i = 1; i <= this.size.doors; i++) { if (this.picks[i]) n++; }
      return n;
    }

    render() {
      var self = this;
      var doors = this.size.doors;
      var filled = this.filledCount();

      [].forEach.call(this.board.children, function (el) {
        if (!el.dataset.i) return;
        var i = Number(el.dataset.i);
        var p = self.picks[i];
        el.classList.toggle('is-filled', !!p);
        el.classList.toggle('is-surprise', !!(p && p.surprise));
        if (p) {
          if (!p.surprise) {
            var img = el.querySelector('.ad__face--back img');
            if (img.getAttribute('src') !== p.image) img.setAttribute('src', p.image);
          }
          el.querySelector('.ad__cap').textContent = p.name;
          el.setAttribute('aria-label', self.t.door + ' ' + el.dataset.pos + ', ' + p.name);
        } else {
          el.setAttribute('aria-label', self.t.door + ' ' + el.dataset.pos);
        }
      });

      var hint = this.querySelector('[data-advent-hint]');
      if (hint) hint.textContent = filled < doors ? this.t.left.replace('[n]', doors - filled) : this.t.ready;

      var fill = this.querySelector('[data-advent-fill]');
      var count = this.querySelector('[data-advent-count]');
      var track = this.querySelector('[data-advent-trackwrap]');
      var cta = this.querySelector('[data-advent-cta]');
      var total = this.querySelector('[data-advent-total]');
      if (total) total.textContent = this.money(this.size.price);

      if (this.step === 3) {
        if (track) track.hidden = true;
        var b1 = this.boxes[1], b2 = this.boxes[2];
        var msg = this.t.boxPick;
        if (b1 && b2) msg = this.t.boxChosen.replace('[a]', b1.label).replace('[b]', b2.label);
        else if (b1) msg = this.t.boxOne.replace('[a]', b1.label);
        else if (b2) msg = this.t.boxTwo.replace('[b]', b2.label);
        if (count) count.textContent = msg;
        this.boxStock();
        if (cta) {
          cta.disabled = !this.boxesDone() || this.busy;
          cta.textContent = this.busy ? this.t.adding : this.t.cta;
        }
      } else {
        if (track) track.hidden = false;
        if (fill) fill.style.width = (filled / doors * 100) + '%';
        if (count) count.textContent = this.t.progress.replace('[a]', filled).replace('[b]', doors);
        if (cta) {
          cta.disabled = filled < doors;
          cta.textContent = this.t.next;
        }
      }

      var list = this.querySelector('[data-advent-list]');
      var sumH = list && list.parentNode.querySelector('h3');
      if (sumH) {
        if (!sumH.dataset.orig) sumH.dataset.orig = sumH.textContent;
        var deL = (document.documentElement.lang || 'de').indexOf('de') === 0;
        sumH.textContent = this.mode === 'all' ? (deL ? 'Alle 24 Türli: Überraschung, passend zu deinem Style' : 'All 24 doors: a surprise matched to your style') : sumH.dataset.orig;
      }
      if (list && filled === doors) {
        var rows = '';
        for (var i = 1; i <= doors; i++) {
          var pk = this.picks[i];
          rows += '<span class="ad__thumb' + (pk.surprise ? ' ad__thumb--gift' : '') + '" title="' + pk.name.replace(/"/g, '&quot;') + '"><b>' + (this.posOf[i] || i) + '</b>' +
            (pk.surprise ? '' : '<img src="' + pk.image + '" alt="" loading="lazy">') + '</span>';
        }
        list.innerHTML = rows;
      }
    }

    taken(id, exceptDoor) {
      for (var k in this.picks) {
        if (Number(k) !== exceptDoor && this.picks[k].id === id) return true;
      }
      return false;
    }

    /* Variantentitel wie "Gold Plated 925 Sterling Silver / A Pair"
       auf "Gold"/"Silber" eindampfen, aber nur wenn sich die Varianten
       eines Produkts eindeutig am Material unterscheiden. */
    matLabel(t) {
      if (/gold/i.test(t)) return this.t.gold || 'Gold';
      if (/silver|silber/i.test(t)) return this.t.silver || 'Silber';
      return null;
    }

    shortVariant(p, v) {
      if (p.v.length < 2) return v.t;
      var seen = {};
      for (var i = 0; i < p.v.length; i++) {
        var m = this.matLabel(p.v[i].t);
        if (!m || seen[m]) return v.t;
        seen[m] = 1;
      }
      return this.matLabel(v.t);
    }

    entry(p, v, disp) {
      if (p.typ) return { id: v.id, image: p.i, name: p.n, typ: true, pn: p.pn || p.n, xv: v.xv || 0 };
      var vt = disp;
      if (!vt) vt = this.niceVariant(v.t);
      var name = vt ? (p.n0 || p.n) + ' · ' + vt : p.n;
      if (this.curPair) name += ' · ' + (this.t.pair || 'Paar') + (v.two ? ' (2 Stück)' : '');
      return { id: v.id, image: v.img || p.i, name: name, two: !!(this.curPair && v.two) };
    }

    /* "Waehl fuer mich": bewusst KEIN konkretes Produkt. Das Team
       packt passend zum Style-Profil, der Kundin wird nichts gezeigt. */
    surpriseEntry() {
      return { surprise: true, id: 0, image: '', name: this.t.surprise || 'Überraschung' };
    }

    /* Produkte mit mehreren Varianten: pro Option ein Dropdown.
       Material zeigt nur "Gold" oder "Silber". Fixe Optionen werden
       vorausgewaehlt und nicht angezeigt. */
    configure(i, p, only) {
      var self = this;
      var open = (only || p.v).filter(function (v) { return v.a && !self.taken(v.id, i); });
      if (!open.length) return;

      this.opts.innerHTML = '';
      var box = document.createElement('div');
      box.className = 'ad__conf';

      var backBtn = document.createElement('button');
      backBtn.type = 'button';
      backBtn.className = 'ad__link';
      backBtn.textContent = '← ' + (this.t.back || 'Zurück');
      backBtn.addEventListener('click', function () { self.open(i); });
      box.appendChild(backBtn);

      var head = document.createElement('div');
      head.className = 'ad__confhead';
      var hi = open.filter(function (v) { return v.img; })[0];
      head.innerHTML = '<img src="' + ((hi && hi.img) || p.i) + '" alt="" data-conf-img><span><b>' + p.n + '</b>' + (this.curPair ? ' <span class="ad__pairtag">' + (this.t.pair || 'Paar') + '</span>' : '') + '</span>';
      box.appendChild(head);

      var names = p.on || [];
      var split = open.map(function (v) { return v.t.split(' / '); });
      var aligned = names.length > 0 && split.every(function (x) { return x.length === names.length; });
      var dims = aligned ? names.length : 1;

      var uniq = [];
      if (aligned) {
        for (var d = 0; d < dims; d++) {
          var seenU = {};
          var c = 0;
          for (var k = 0; k < open.length; k++) {
            if (!seenU[split[k][d]]) { seenU[split[k][d]] = 1; c++; }
          }
          uniq.push(c);
        }
      }

      var sels = [];
      var confirm = document.createElement('button');
      confirm.type = 'button';
      confirm.className = 'ad__btn';
      confirm.textContent = this.t.confirm || 'OK';
      confirm.disabled = true;

      var matDim = function (d) {
        return split.every(function (x) { return self.matLabel(x[d]); });
      };
      var allMat = open.every(function (v) { return self.matLabel(v.t); });

      var currentMatch = function () {
        if (!aligned) {
          return sels[0] && sels[0].value !== '' ? open[Number(sels[0].value)] : null;
        }
        for (var k = 0; k < open.length; k++) {
          var ok = true;
          for (var d = 0; d < dims; d++) {
            if (sels[d].value === '' || split[k][d] !== sels[d].value) { ok = false; break; }
          }
          if (ok) return open[k];
        }
        return null;
      };

      var update = function () {
        if (aligned) {
          for (var d = 0; d < dims; d++) {
            var os = sels[d].options;
            for (var o = 0; o < os.length; o++) {
              if (os[o].value === '') continue;
              var possible = false;
              for (var k = 0; k < open.length; k++) {
                if (split[k][d] !== os[o].value) continue;
                var fits = true;
                for (var e = 0; e < dims; e++) {
                  if (e !== d && sels[e].value !== '' && split[k][e] !== sels[e].value) { fits = false; break; }
                }
                if (fits) { possible = true; break; }
              }
              os[o].disabled = !possible;
            }
          }
        }
        var cm = currentMatch();
        confirm.disabled = !cm;
        var ci = box.querySelector('[data-conf-img]');
        if (ci && cm && cm.img) ci.src = cm.img;
      };

      var makeSel = function (labelText) {
        var wrap = document.createElement('label');
        wrap.className = 'ad__confrow';
        var span = document.createElement('span');
        span.textContent = labelText;
        var sel = document.createElement('select');
        sel.className = 'ad__sel';
        var ph = document.createElement('option');
        ph.value = '';
        ph.disabled = true;
        ph.selected = true;
        ph.textContent = self.t.choose || 'Wählen…';
        sel.appendChild(ph);
        sel.addEventListener('change', update);
        wrap.appendChild(span);
        wrap.appendChild(sel);
        box.appendChild(wrap);
        sels.push(sel);
        return sel;
      };

      var optName = function (n) {
        return (self.t.optmap && self.t.optmap[n]) || n;
      };

      if (!aligned) {
        var sel1 = makeSel(optName(names[0] || (this.t.variant || 'Variante')));
        for (var k1 = 0; k1 < open.length; k1++) {
          var o1 = document.createElement('option');
          o1.value = String(k1);
          o1.textContent = allMat ? this.matLabel(open[k1].t) : open[k1].t;
          sel1.appendChild(o1);
        }
        if (open.length === 1) { sel1.selectedIndex = 1; }
      } else {
        for (var d2 = 0; d2 < dims; d2++) {
          var isMat = matDim(d2);
          var sel2 = makeSel(optName(names[d2]));
          var seen = {};
          for (var k2 = 0; k2 < open.length; k2++) {
            var val = split[k2][d2];
            if (seen[val]) continue;
            seen[val] = 1;
            var o2 = document.createElement('option');
            o2.value = val;
            o2.textContent = isMat ? this.matLabel(val) : val;
            sel2.appendChild(o2);
          }
          if (sel2.options.length === 2) {
            sel2.selectedIndex = 1;
            sel2.parentNode.hidden = true;
          }
        }
      }
      update();

      confirm.addEventListener('click', function () {
        var v = currentMatch();
        if (!v) return;
        var disp = null;
        if (aligned) {
          var partsSel = [];
          for (var d = 0; d < dims; d++) {
            if (uniq[d] < 2) continue;
            partsSel.push(matDim(d) ? self.matLabel(sels[d].value) : sels[d].value);
          }
          if (partsSel.length) disp = partsSel.join(' · ');
        } else if (allMat) {
          disp = self.matLabel(v.t);
        }
        self.choose(i, self.entry(p, v));
      });
      box.appendChild(confirm);

      this.opts.appendChild(box);
      this.opts.scrollTop = 0;
    }

    open(i) {
      var self = this;
      if (i < 1 || i > this.size.doors) return;
      var cat = this.catFor(i);
      this.curPair = !!cat.pair;
      if (!this.mat) this.mat = this.profileMat();

      this.querySelector('[data-advent-step]').textContent = this.t.door + ' ' + (this.posOf[i] || i) + ' · ' + (this.t.of || '[a] von [b]').replace('[a]', i).replace('[b]', this.size.doors);
      this.querySelector('[data-advent-title]').textContent = cat.t;
      this.querySelector('[data-advent-sub]').textContent = cat.b || '';
      this.opts.innerHTML = '';
      this.sheetBar(i, cat);

      var luck = document.createElement('button');
      luck.type = 'button';
      luck.className = 'ad__opt ad__opt--luck';
      if (this.picks[i] && this.picks[i].surprise) luck.classList.add('is-on');
      luck.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1.4l3.2 6.6 7.3 1-5.3 5.1 1.3 7.2L12 17.9l-6.5 3.4 1.3-7.2L1.5 9l7.3-1Z"/></svg>' +
        '<span><span class="ad__on">' + this.t.luck + '</span>' +
        '<span class="ad__op">' + this.t.luckSub + '</span></span>';
      luck.addEventListener('click', function () { self.choose(i, self.surpriseEntry()); });
      this.opts.appendChild(luck);

      var shown = 0;
      cat.o.forEach(function (p) {
        if (!p.v.length) return;
        var mine = p.typ ? p.v : self.forMat(p.v);
        if (p.sub) {
          var subOk = p.sub.some(function (sp) { return (sp.q === null || sp.q === undefined || sp.q >= 1) && !self.taken(sp.id, i); });
          if (!subOk) return; /* 11.10.2026: nichts mehr da -> Option ausblenden */
        }
        if (!mine.length) return;
        /* 11.10.2026: ausverkaufte Modelle ausblenden (auch im gewaehlten Material) */
        if (!mine.some(function (v) { return v.a; })) return;
        var open = mine.filter(function (v) { return v.a && !self.taken(v.id, i); });
        shown++;
        var card = document.createElement('div');
        card.className = 'ad__opt' + (p.typ ? ' ad__opt--typ' : '');
        var chosen = self.picks[i] && mine.some(function (v) { return v.id === self.picks[i].id; });
        if (chosen) card.classList.add('is-on');
        if (!open.length) card.classList.add('is-off');
        var img = p.i;
        if (!p.typ) { var withImg = (open[0] || mine[0]); if (withImg && withImg.img) img = withImg.img; }

        var flag = '';
        if (!open.length) flag = '<span class="ad__flag">' + (mine.some(function (v) { return v.a; }) ? self.t.already : self.t.soldout) + '</span>';

        card.innerHTML =
          '<img src="' + img + '" alt="" loading="lazy">' +
          '<span class="ad__ob"><span class="ad__on">' + p.n + '</span>' +
          (cat.pair ? '<span class="ad__pairtag">' + (self.t.pair || 'Paar') + '</span>' : '') +
          (p.typ ? (p.sub ? '<span class="ad__typnote ad__typnote--pick">' + (p.icon === 'beanie' ? (self.t.colorPick || 'Farbe wählst du') : (self.t.designPick || 'Design wählst du')) + '</span>' : (p.icon === 'tag' || p.icon === 'case' ? '' : '<span class="ad__typnote">' + (self.t.designSurprise || 'Design: Überraschung') + '</span>')) : '') + flag + '</span>';

        if (open.length) {
          card.setAttribute('role', 'button');
          card.tabIndex = 0;
          var pick = function () {
            if (p.sub) { self.openSub(i, p); return; }
            if (open.length === 1) self.choose(i, self.entry(p, open[0]));
            else self.configure(i, p, mine);
          };
          card.addEventListener('click', pick);
          card.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
          });
        }
        self.opts.appendChild(card);
      });

      if (!shown) {
        var empty = document.createElement('p');
        empty.className = 'ad__empty';
        empty.textContent = this.t.empty;
        this.opts.appendChild(empty);
      }

      this.opts.scrollTop = 0;
      if (!this.sheet.open && typeof this.sheet.showModal === 'function') this.sheet.showModal();
    }

    /* Zweite Stufe fuer Typ-Optionen mit eigener Auswahl (z.B. Portemonnaie-Design).
       Gewaehlt wird ein echtes Produkt, das wie Schmuck abgebucht wird. */
    openSub(i, p) {
      var self = this;
      this.opts.innerHTML = '';
      var head = document.createElement('div');
      head.className = 'ad__subhead';
      var back = document.createElement('button');
      back.type = 'button';
      back.className = 'ad__link';
      back.textContent = '← ' + (this.t.back || 'Zurück');
      back.addEventListener('click', function () { self.open(i); });
      var tt = document.createElement('b');
      tt.textContent = p.n + ': ' + (p.icon === 'beanie' ? (this.t.subColor || 'Welche Farbe?') : (this.t.subTitle || 'Welches Design?'));
      head.appendChild(back);
      head.appendChild(tt);
      this.opts.appendChild(head);
      var list = p.sub.slice().sort(function (a, b) { return (b.q || 0) - (a.q || 0); });
      list.forEach(function (sp) {
        var inStock = sp.q === null || sp.q === undefined || sp.q >= 1;
        if (!inStock) return; /* 11.10.2026: ausverkaufte Designs ausblenden */
        var ok = !self.taken(sp.id, i);
        var card = document.createElement('div');
        card.className = 'ad__opt' + (ok ? '' : ' is-off');
        if (self.picks[i] && self.picks[i].id === sp.id) card.classList.add('is-on');
        card.innerHTML = '<img src="' + sp.i + '" alt="" loading="lazy"><span class="ad__ob"><span class="ad__on">' + sp.n + '</span>' +
          (ok ? '' : '<span class="ad__flag">' + self.t.already + '</span>') + '</span>';
        if (ok) {
          card.setAttribute('role', 'button');
          card.tabIndex = 0;
          var go = function () { self.choose(i, { id: sp.id, image: sp.i, name: p.n + ' · ' + sp.n }); };
          card.addEventListener('click', go);
          card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
        }
        self.opts.appendChild(card);
      });
      this.opts.scrollTop = 0;
    }

    choose(i, entry) {
      this.picks[i] = entry;
      this.render();
      this.sheet.close();
      var next = this.nextEmpty(i);
      var self = this;
      if (next) setTimeout(function () { self.open(next); }, 620);
    }

    nextEmpty(from) {
      for (var i = from + 1; i <= this.size.doors; i++) { if (!this.picks[i]) return i; }
      for (var j = 1; j <= this.size.doors; j++) { if (!this.picks[j]) return j; }
      return 0;
    }

    fillAll() {
      for (var i = 1; i <= this.size.doors; i++) {
        if (this.picks[i]) continue;
        this.picks[i] = this.surpriseEntry();
      }
      this.render();
    }

    root() {
      return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    }

    /* Style-Profil auslesen. ok=false, wenn Pflichtfragen offen sind. */
    quizData() {
      var quiz = document.getElementById('ruru-quiz');
      if (!quiz) return { ok: true, props: {}, el: null };
      var props = {};
      var ok = true;
      var groups = {};
      quiz.querySelectorAll('input[type="radio"]').forEach(function (r) {
        var name = r.name.replace(/^properties\[/, '').replace(/\]$/, '');
        if (!(name in groups)) groups[name] = null;
        if (r.checked) groups[name] = r.value;
      });
      for (var g in groups) {
        if (groups[g]) props[g] = groups[g]; else ok = false;
      }
      quiz.querySelectorAll('select').forEach(function (s) {
        var name = s.name.replace(/^properties\[/, '').replace(/\]$/, '');
        if (s.value) props[name] = s.value; else if (s.required) ok = false;
      });
      quiz.querySelectorAll('input[data-multi]').forEach(function (h) {
        var name = h.name.replace(/^properties\[/, '').replace(/\]$/, '');
        if (h.value) props[name] = h.value;
        else if (h.hasAttribute('data-required')) {
          ok = false;
          var err = h.closest('.ruru-quiz__q') && h.closest('.ruru-quiz__q').querySelector('[data-multi-error]');
          if (err) err.hidden = false;
        }
      });
      quiz.querySelectorAll('textarea[name^="properties["]').forEach(function (t) {
        var name = t.name.replace(/^properties\[/, '').replace(/\]$/, '');
        if (t.value.trim()) props[name] = t.value.trim();
      });
      var colors = document.getElementById('ruru-quiz-colors-value');
      if (colors) {
        if (colors.value) props['Farben'] = colors.value; else ok = false;
      }
      return { ok: ok, props: props, el: quiz };
    }

    /* 12.10.2026: Beim Ablegen in den Warenkorb eine kleine weihnachtliche
       Animation: Schmuck faellt in die Box, Deckel zu, Masche drauf.
       Laeuft parallel zum Warenkorb-Aufruf, mindestens ca. 3 Sekunden. */
    packAnim() {
      var de = (document.documentElement.lang || 'de').indexOf('de') === 0;
      if (!document.getElementById('ruru-pack-css')) {
        var st = document.createElement('style');
        st.id = 'ruru-pack-css';
        st.textContent =
          '.rpk{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;background:rgba(193,217,250,.92);opacity:0;transition:opacity .3s ease;font-family:inherit}' +
          '.rpk.is-on{opacity:1}' +
          '.rpk__card{position:relative;width:min(340px,86vw);padding:28px 22px 26px;border-radius:26px;background:#fff;box-shadow:0 24px 60px rgba(52,73,106,.22);text-align:center;color:#34496a;overflow:hidden}' +
          '.rpk svg{display:block;width:220px;height:200px;margin:0 auto 6px;overflow:visible}' +
          '.rpk__t{font-family:"ruru Gabarito",inherit;font-size:21px;font-weight:800;margin:4px 0 4px}' +
          '.rpk__s{font-size:14px;opacity:.75;margin:0}' +
          '.rpk__it{opacity:0;animation:rpkDrop .7s cubic-bezier(.3,.7,.4,1) forwards}' +
          '.rpk__it--1{animation-delay:.2s}.rpk__it--2{animation-delay:.55s}.rpk__it--3{animation-delay:.9s}.rpk__it--4{animation-delay:1.2s}' +
          '@keyframes rpkDrop{0%{opacity:0;transform:translateY(-90px) rotate(-20deg)}60%{opacity:1}100%{opacity:1;transform:translateY(0) rotate(0)}}' +
          '.rpk__lid{transform-origin:110px 92px;transform:translateY(-70px) rotate(-14deg);opacity:0;animation:rpkLid .55s cubic-bezier(.3,.8,.4,1.2) 1.7s forwards}' +
          '@keyframes rpkLid{0%{opacity:0;transform:translateY(-70px) rotate(-14deg)}40%{opacity:1}100%{opacity:1;transform:translateY(0) rotate(0)}}' +
          '.rpk__bow{transform-origin:110px 86px;transform:scale(0);animation:rpkBow .5s cubic-bezier(.3,1.6,.5,1) 2.25s forwards}' +
          '@keyframes rpkBow{to{transform:scale(1)}}' +
          '.rpk__ribbon{transform-origin:110px 100px;transform:scaleY(0);animation:rpkRib .35s ease-out 2.05s forwards}' +
          '@keyframes rpkRib{to{transform:scaleY(1)}}' +
          '.rpk__sp{opacity:0;transform-origin:center;transform-box:fill-box;animation:rpkSp 1.2s ease-in-out 2.5s infinite}' +
          '.rpk__sp--b{animation-delay:2.8s}.rpk__sp--c{animation-delay:3.1s}' +
          '@keyframes rpkSp{0%,100%{opacity:0;transform:scale(.4)}50%{opacity:1;transform:scale(1.1)}}' +
          '.rpk__box{animation:rpkHop .5s ease-in-out 2.6s 2}' +
          '@keyframes rpkHop{0%,100%{transform:translateY(0)}50%{transform:translateY(-6px)}}' +
          '.rpk__snow{position:absolute;inset:0;pointer-events:none;background-image:radial-gradient(3px 3px at 15% 20%,#c1d9fa 50%,transparent 51%),radial-gradient(2.5px 2.5px at 80% 30%,#f4e0f8 50%,transparent 51%),radial-gradient(3px 3px at 60% 80%,#fbb9cf 50%,transparent 51%),radial-gradient(2px 2px at 30% 70%,#c1d9fa 50%,transparent 51%);background-size:160px 160px;animation:rpkSnow 6s linear infinite}' +
          '@keyframes rpkSnow{to{background-position:0 160px,0 160px,0 160px,0 160px}}' +
          '@media (prefers-reduced-motion:reduce){.rpk *{animation-duration:.01s!important;animation-delay:0s!important}}';
        document.head.appendChild(st);
      }
      var star = 'M0-9 2.2-2.2 9 0 2.2 2.2 0 9-2.2 2.2-9 0-2.2-2.2Z';
      var el = document.createElement('div');
      el.className = 'rpk';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.innerHTML =
        '<div class="rpk__card"><div class="rpk__snow"></div>' +
        '<svg viewBox="0 0 220 200" aria-hidden="true">' +
          '<g class="rpk__box">' +
            /* Schmuck, der hineinfaellt */
            '<g class="rpk__it rpk__it--1"><circle cx="82" cy="104" r="11" fill="none" stroke="#e7b84a" stroke-width="4"/><circle cx="82" cy="92" r="4" fill="#fff" stroke="#c1d9fa" stroke-width="2"/></g>' +
            '<g class="rpk__it rpk__it--2"><path d="M112 88c-8 0-8 16 0 16s8-16 0-16Z" fill="none" stroke="#e7b84a" stroke-width="3.5"/><circle cx="112" cy="108" r="4" fill="#fbb9cf"/></g>' +
            '<g class="rpk__it rpk__it--3"><path transform="translate(140 98)" d="' + star + '" fill="#e7b84a"/></g>' +
            '<g class="rpk__it rpk__it--4"><path d="M96 100c0-6 8-6 8 0 0-6 8-6 8 0 0 6-8 11-8 11s-8-5-8-11Z" fill="#d23a50"/></g>' +
            /* Box */
            '<rect x="50" y="108" width="120" height="70" rx="10" fill="#fbb9cf"/>' +
            '<rect x="50" y="108" width="120" height="12" fill="#f4a3be"/>' +
            '<rect class="rpk__ribbon" x="103" y="108" width="14" height="70" fill="#d23a50"/>' +
            /* Deckel */
            '<g class="rpk__lid"><rect x="42" y="92" width="136" height="22" rx="8" fill="#fc78a4"/><rect x="103" y="92" width="14" height="22" fill="#d23a50"/></g>' +
            /* Masche */
            '<g class="rpk__bow"><path d="M110 90c-14-18-36-16-30-2 4 9 18 6 30 2Z" fill="#d23a50"/><path d="M110 90c14-18 36-16 30-2-4 9-18 6-30 2Z" fill="#d23a50"/><path d="M110 92l-10 18M110 92l10 18" stroke="#d23a50" stroke-width="5" stroke-linecap="round"/><circle cx="110" cy="90" r="6" fill="#a8203a"/></g>' +
          '</g>' +
          '<path class="rpk__sp" transform="translate(34 70)" d="' + star + '" fill="#e4a4f0"/>' +
          '<path class="rpk__sp rpk__sp--b" transform="translate(190 60) scale(.8)" d="' + star + '" fill="#82b0f0"/>' +
          '<path class="rpk__sp rpk__sp--c" transform="translate(186 150) scale(.6)" d="' + star + '" fill="#fc78a4"/>' +
        '</svg>' +
        '<p class="rpk__t">' + (de ? 'Wir packen deinen Kalender' : 'Packing your calendar') + '</p>' +
        '<p class="rpk__s">' + (de ? '24 Türli voller Schmuck, gleich ist er im Warenkorb.' : '24 doors full of jewellery, almost in your cart.') + '</p>' +
        '</div>';
      document.body.appendChild(el);
      requestAnimationFrame(function () { el.classList.add('is-on'); });
      var start = Date.now();
      var close = function () {
        el.classList.remove('is-on');
        setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 350);
      };
      return {
        finish: function (ok) {
          if (!ok) { close(); return Promise.resolve(); }
          var wait = Math.max(0, 3200 - (Date.now() - start));
          return new Promise(function (resolve) {
            setTimeout(function () {
              var t = el.querySelector('.rpk__t');
              var sub = el.querySelector('.rpk__s');
              if (t) t.textContent = de ? 'Fertig gepackt!' : 'All packed!';
              if (sub) sub.textContent = de ? 'Dein Adventskalender liegt im Warenkorb.' : 'Your advent calendar is in your cart.';
              setTimeout(function () { close(); resolve(); }, 900);
            }, wait);
          });
        }
      };
    }

    async addToCart() {
      if (this.busy || !this.boxesDone()) return;
      var doors = this.size.doors;
      if (this.filledCount() < doors) { this.setStep(2); return; }

      var quiz = this.quizData();
      if (!quiz.ok) {
        this.setStep(1);
        var qs = this.querySelector('[data-advent-quiz-status]');
        if (qs) qs.textContent = this.t.quiz || this.t.error;
        return;
      }

      this.busy = true;
      this.status.textContent = '';
      this.render();

      /* Properties mit "_" sind fuer die Kundin unsichtbar (Ueberraschung
         bleibt Ueberraschung), im Admin bei der Bestellung sichtbar.
         Die Boxfarben bewusst OHNE "_", damit die Kundin sie sieht. */
      /* Gewaehlte Tuerchen sichtbar (Kundin sieht ihre Wahl im Warenkorb und
         in der Bestellbestaetigung), Nummer = Tuerchen auf dem Kalender.
         Die 12 festen Ueberraschungen tauchen hier nicht auf. */
      var props = {};
      var ids = [];
      var extra = 0;
      var allSurprise = this.mode === 'all';
      if (allSurprise) props[(document.documentElement.lang || 'de').indexOf('de') === 0 ? 'Türli' : 'Doors'] = (document.documentElement.lang || 'de').indexOf('de') === 0 ? 'Alle 24 als Überraschung, passend zu deinem Style' : 'All 24 as a surprise, matched to your style';
      props._advent_mode = allSurprise ? 'alles-ueberraschung' : 'selbst';
      for (var d = 1; d <= doors; d++) {
        var pk = this.picks[d];
        var key = (this.t.doorProp || 'Türli [n]').replace('[n]', this.posOf[d] || d);
        if (!allSurprise) props[key] = pk.surprise ? (this.t.forYou || 'Wir wählen für dich') : pk.name;
        ids.push(pk.surprise ? 'surprise' : (pk.typ ? 'typ:' + (pk.pn || pk.name) : pk.id + (pk.two ? 'x2' : '')));
        if (pk.typ && pk.xv) extra = pk.xv;
      }
      props['Box 1'] = this.boxes[1].value;
      props['Box 2'] = this.boxes[2].value;
      props._advent_ids = ids.join(',');
      props._advent_boxes = [this.boxes[1].variant, this.boxes[2].variant].filter(Boolean).join(',');
      if (extra) props._advent_extra = String(extra);
      /* Style-Profil versteckt, die Geschenkkarte sichtbar (Kundin soll ihren Text sehen). */
      for (var q in quiz.props) props[q === 'Geschenkkarte' ? q : '_' + q] = quiz.props[q];

      var anim = this.packAnim();
      try {
        var items = [{ id: this.size.variant, quantity: 1, properties: props }];
        var up = this.querySelector('[data-advent-upsell]');
        if (up && up.checked) items.push({ id: Number(up.value), quantity: 1 });
        /* Boxen und Extra NICHT als eigene Warenkorb-Positionen (Wunsch 10.10.2026:
           im Warenkorb unsichtbar). Die Varianten stehen in versteckten Properties,
           die stuendliche Aufgabe bucht sie vom Lager ab. */
        var res = await fetch(this.root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
        var data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || 'cart');
        await anim.finish(true);
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('[data-cart-drawer-toggle]');
        if (drawer) drawer.click();
      } catch (err) {
        anim.finish(false);
        this.status.textContent = this.t.error;
      } finally {
        this.busy = false;
        this.render();
      }
    }
  });
}
